<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md6>
				<v-layout row wrap>
					<v-flex xs12 md6>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Daily</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ customer_daily_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Daily New Registered
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80"
										>mdi-calendar-today</v-icon
									>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" outlined>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">
										Total customer
									</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ customer_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Total customer
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80"
										>mdi-account-group-outline</v-icon
									>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md6>
				<v-layout row wrap>
					<v-flex xs12 md6>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Male</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ customer_male_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Male
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-human-male</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card class="mx-auto" color="primary" outlined dark>
							<v-list-item three-line>
								<v-list-item-content>
									<div class="text-overline mb-4">Female</div>
									<v-list-item-title class="text-h5 mb-1">
										{{ customer_female_count }}
									</v-list-item-title>
									<v-list-item-subtitle>
										Female
									</v-list-item-subtitle>
								</v-list-item-content>

								<v-list-item-avatar tile size="80">
									<v-icon size="80">mdi-human-female</v-icon>
								</v-list-item-avatar>
							</v-list-item>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>

			<v-flex xs12 md6>
				<v-card>
					<v-card-title>Top 10 reservations</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<apexchart
							max-width="800"
							type="line"
							:options="options"
							:series="series"
						></apexchart>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md6>
				<v-card>
					<v-card-title>Top 10 orders</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<apexchart
							max-width="800"
							type="line"
							:options="options"
							:series="series_order"
						></apexchart>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import CentralLayout from "../../../../layouts/central.vue";
import CentralCustomerLayout from "../../../../layouts/partials/central/customer.vue";
export default {
	layout: [CentralLayout, CentralCustomerLayout],
	props: [
		"customer_count",
		"customer_daily_count",
		"customer_male_count",
		"customer_female_count",
		"customer_orders",
		"customer_reservations",
	],

	data() {
		return {
			options: {
				chart: {
					id: "vuechart-example",
				},
				xaxis: {
					categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
				},
				toolbar: {
					show: false,
				},
			},
			series: [
				{
					name: "reservation",
					data: this.customer_reservations,
				},
			],
			series_order: [
				{
					name: "order",
					data: this.customer_orders,
				},
			],
		};
	},
};
</script>